import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Css/sideBar.css';
import Logo from './Img/logo.svg';

const SideBar = ({ isOpen }) => {
    const [openSubMenu, setOpenSubMenu] = useState(null);
    const [permissions, setPermissions] = useState({});
    const [pagesOpen, setPagesOpen] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const role = (localStorage.getItem('userRole'));


    useEffect(() => {

        const storedPermissions = JSON.parse(localStorage.getItem('userPermissions')) || {};
        setPermissions(storedPermissions);

    }, []);

    const handleToggleSubMenu = (menu) => {
        setOpenSubMenu(openSubMenu === menu ? null : menu);
    };

    const togglePages = () => setPagesOpen(!pagesOpen);
    const toggleSettings = () => setSettingsOpen(!settingsOpen);

    const renderMenuItem = (name, key, icon, img, subItems) => {
        if (role === 'Admin' || permissions[key]) {
            return (
                <li key={key}>
                    {subItems ? (
                        <>
                            <a onClick={() => handleToggleSubMenu(key)} style={{ cursor: 'pointer' }}>
                                {icon ? <i className={`fa fa-${icon}`} /> : <img src={img} alt={name} style={{ marginInlineEnd: 10 }} />}
                                {name}
                                <i className={`fa ${openSubMenu === key ? 'fa-chevron-down' : 'fa-chevron-right'}`} style={{ float: 'right' }} />
                            </a>
                            {openSubMenu === key && (
                                <ul style={{ listStyleType: 'none', marginLeft: '20px', borderLeft: '5px solid #23334A' }}>
                                    {subItems.map((subItem) => (
                                        <li key={subItem.key} style={{  marginTop: '5px' }}>
                                            <NavLink to={subItem.path} className="sub-link" activeClassName="active">
                                                {subItem.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </>
                    ) : (
                        <NavLink to={`/${key}`} activeClassName="active">
                            {icon ? <i className={`fa fa-${icon}`} /> : <img src={img} alt={name} style={{ marginInlineEnd: 10 }} />}
                            {name}
                        </NavLink>
                    )}
                </li>
            );
        }
        return null;
    };

    const menuItems = [
        { name: 'Dashboard', key: 'dashboard', img: 'img/dashboard.svg' },
        { name: 'Booking', key: 'booking', img: 'img/booking.svg' },
        { name: 'User Manager', key: 'user-manager', icon: 'id-card-o' },
        {
            name: 'Investor Management',
            key: 'investor-management',
            img: 'img/investor.svg',
            subItems: [
                { name: 'Investor List', path: '/investor-list' },
                { name: 'Investor Earning List', path: '/investor-earning' },
                { name: 'Investor Withdrawl List', path: '/investor-withdrawal' }
            ],
        },
        { name: 'Category', key: 'category-list', img: 'img/cottage.svg' },
        { name: 'Cottage List', key: 'cottage-list',path: '/cottage-list', img: 'img/cottage.svg' },
        { name: 'Cottage Inventory List', key: 'inventory-list',path: '/inventory-list', img: 'img/inventory.svg' },
        { name: 'App Banner', key: 'app-banner-list',path: '/app-banner-list', img: 'img/banner.svg' },
        { name: 'Coupon Code', key: 'coupon-code',path: '/coupon-code', img: 'img/coupon.svg' },
        { name: 'Manage Review', key: 'manage-review',path: '/manage-review', img: 'img/review.svg' },
        {
            name: 'Pages',
            key: 'pages',
            img: 'img/pages.svg',
            subItems: [
                { name: 'Privacy Policy', path: '/privacy-policy' },
                { name: 'Terms & Conditions', path: '/term-and-condition' },
                { name: 'Refund Policy', path: '/refund-policy' },
            ],
        },
        { name: 'Notification', key: 'notification-list',path: '/notification-list', img: 'img/notification.svg' },
        {
            name: 'Help Center',
            key: 'help',
            img: 'img/help.svg',
            subItems: [
                { name: 'FAQs Category', path: '/faq-category-list' },
                { name: 'FAQs', path: '/faq-list' },
                { name: 'Contact Us', path: '/contact' },
                { name: 'Ticket Management', path: '/ticket-management' },
            ],
        },
        {
            name: 'Settings',
            key: 'settings',
            img: 'img/setting.svg',
            subItems: [
                { name: 'Profile', path: '/profile' },
                { name: 'Refer & Earn', path: '/refer' },
                { name: 'Admin User List', path: '/admin-user' }
            ],
        },
    ];

    return (
        <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>

            <div className="logo-container">
                <NavLink to="/dashboard" activeClassName="active">
                    <img src={Logo} alt="Logo" className="logo" />
                </NavLink>
            </div>

            <ul className="sidebar-menu">
              <li className='sidebar-item'>
                {menuItems.map((item) => renderMenuItem(item.name, item.key, item.icon, item.img, item.subItems))}
                </li>
            </ul>

        </div>

    );
};

export default SideBar;
// import React, { useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {  faChevronDown, faChevronRight  } from '@fortawesome/free-solid-svg-icons';
// import { NavLink } from 'react-router-dom';
// import './Css/sideBar.css';
// import Logo from './Img/logo.svg';

// const Sidebar = ({ isOpen }) => {  // Accept isOpen prop
//   const [pagesOpen, setPagesOpen] = useState(false);
//   const [settingsOpen, setSettingsOpen] = useState(false);
//   const [investorOpen, setInvestorOpen] = useState(false);
//   const [helpOpen, setHelpOpen] = useState(false);

//   const togglePages = () => setPagesOpen(!pagesOpen);
//   const toggleSettings = () => setSettingsOpen(!settingsOpen);
//   const toggleInvestors = () => setInvestorOpen(!investorOpen);
//   const toggleHelp = () => setHelpOpen(!helpOpen);

//   return (
//     <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}> {/* Apply classes based on isOpen */}
//       <div className="logo-container">
//         <NavLink to="/dashboard" activeClassName="active">
//           <img src={Logo} alt="Logo" className="logo" />
//           </NavLink>
//       </div>
//       <ul className="sidebar-menu">
//         <li className="sidebar-item">
//           <NavLink to="/dashboard" activeClassName="active">
//          <img src="img/dashboard.svg" />
//             <span>Dashboard</span>
//           </NavLink>
//         </li>
//         <li className="sidebar-item">
//           <NavLink to="/booking" activeClassName="active">
//             <img src="img/booking.svg" />
//             <span>Booking</span>
//           </NavLink>
//         </li>
//         <li className="sidebar-item">
//           <NavLink to="/user-manager" activeClassName="active">
//           <i className="fa fa-id-card-o"></i>
//             <span>User Manager</span>
//           </NavLink>
//         </li>
//         <li className={`sidebar-item has-sub-menus ${investorOpen ? 'active' : ''}`} onClick={toggleInvestors }>
//         <img src="img/investor.svg" />
//           <span>Invetsor Management</span>
//           <FontAwesomeIcon icon={investorOpen ? faChevronDown : faChevronRight} className="submenu-icon" />
//         </li>
//         {investorOpen && (
//           <ul className="submenu">
//             <li className="submenu-item">
//               <NavLink to="/investor-list" activeClassName="active">Invetsor List</NavLink>
//             </li>
//             <li className="submenu-item">
//               <NavLink to="/investor-earning" activeClassName="active">Invetsor Earning List</NavLink>
//             </li>
//             <li className="submenu-item">
//               <NavLink to="/investor-withdrawal" activeClassName="active">Invetsor Withdrawl List</NavLink>
//             </li>
//           </ul>
//         )}
//         <li className="sidebar-item">
//           <NavLink to="/cottage-list" activeClassName="active">
//           <img src="img/cottage.svg" />
//             <span>Cottage List</span>
//           </NavLink>
//         </li>
//         <li className="sidebar-item">
//           <NavLink to="/app-banner-list" activeClassName="active">
//             <img src="img/banner.svg" />
//             <span>App Banner</span>
//           </NavLink>
//         </li>
//         <li className="sidebar-item">
//           <NavLink to="/coupon-code" activeClassName="active">
//             <img src="img/coupon.svg" />
//             <span>Coupon Code</span>
//           </NavLink>
//         </li>
//         <li className="sidebar-item">
//           <NavLink to="/inventory-list" activeClassName="active">
//             <img src="img/inventory.svg" />
//             <span>Inventory List</span>
//           </NavLink>
//         </li>
//         <li className="sidebar-item">
//           <NavLink to="/manage-review" activeClassName="active">
//           <img src="img/review.svg" />
//             <span>Manage Review</span>
//           </NavLink>
//         </li>
//         <li className={`sidebar-item has-sub-menus ${pagesOpen ? 'active' : ''}`} onClick={togglePages}>
//         <img src="img/pages.svg" />
//           <span>Pages</span>
//           <FontAwesomeIcon icon={pagesOpen ? faChevronDown : faChevronRight} className="submenu-icon" />
//         </li>
//         {pagesOpen && (
//           <ul className="submenu">
//             <li className="submenu-item">
//               <NavLink to="/privacy-policy" activeClassName="active">Privacy Policy</NavLink>
//             </li>
//             <li className="submenu-item">
//               <NavLink to="/term-and-condition" activeClassName="active">Terms & Conditions</NavLink>
//             </li>
//             <li className="submenu-item">
//               <NavLink to="/refund-policy" activeClassName="active">Refund Policy</NavLink>
//             </li>
//           </ul>
//         )}
//         <li className="sidebar-item">
//           <NavLink to="/notification-list" activeClassName="active">
//            <img src="img/notification.svg" />
//             <span>Notification</span>
//           </NavLink>
//         </li>
//         <li className={`sidebar-item has-sub-menus ${helpOpen ? 'active' : ''}`} onClick={toggleHelp}>
//           <img src="img/help.svg" />
//           <span>Help Center</span>
//           <FontAwesomeIcon icon={helpOpen ? faChevronDown : faChevronRight} className="submenu-icon" />
//         </li>
//         {helpOpen && (
//           <ul className="submenu">
//           <li className="submenu-item">
//               <NavLink to="/faq-category-list" activeClassName="active">FAQs Category</NavLink>
//             </li>
//             <li className="submenu-item">
//               <NavLink to="/faq-list" activeClassName="active">FAQs</NavLink>
//             </li>
//             <li className="submenu-item">
//               <NavLink to="/contact" activeClassName="active">Contact Us</NavLink>
//             </li>
//             <li className="submenu-item">
//               <NavLink to="/ticket-management" activeClassName="active">Ticket Management</NavLink>
//             </li>
//           </ul>
//         )}
       
//         <li className={`sidebar-item has-sub-menus ${settingsOpen ? 'active' : ''}`} onClick={toggleSettings}>
//           <img src="img/setting.svg" />
//           <span>Settings</span>
//           <FontAwesomeIcon icon={settingsOpen ? faChevronDown : faChevronRight} className="submenu-icon" />
//         </li>
//         {settingsOpen && (
//           <ul className="submenu">
//             <li className="submenu-item">
//               <NavLink to="/profile" activeClassName="active">Profile</NavLink>
//             </li>
//             <li className="submenu-item">
//               <NavLink to="/admin-user" activeClassName="active">Admin User List</NavLink>
//             </li>
//           </ul>
//         )}
//       </ul>
//     </div>
//   );
// };

// export default Sidebar;